import React, { useState } from 'react';
import {
  FormControlLabel,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import GenericButton from './GenericButton';

const AcceptTermsModal = props => {
  const { isOpen, acceptedOnClick } = props;
  const [accepted, setAccepted] = useState(false);

  return (
    <Dialog open={isOpen} scroll="paper" fullWidth maxWidth="md">
      <DialogTitle style={{ display: 'flex', justifyContent: 'center' }}>
        Important Reminder of Critical Usage Requirements
      </DialogTitle>
      <DialogContent style={{ padding: '0 2rem' }} dividers>
        <p style={{ fontWeight: 700, margin: '1rem 0' }}>
          You must accept these terms in order to use Catalyst.
        </p>
        <p style={{ fontWeight: 700 }}>
          Prior, written approval from MRI-Simmons is required to:
        </p>
        <ol>
          <li>
            Share or provide access to MRI-Simmons data with your company’s
            entities, affiliates, divisions, or units not expressly named in the
            license agreement; your customers who do not have a current license
            to MRI-Simmons data; or your external, third-party vendors. There
            are limited exceptions for:
            <ol type="a">
              <li>
                Staff augmentation personnel (e.g., temporary employees) working
                solely for you and in accordance with your current MRI-Simmons
                data license
              </li>
              <li>
                IT services and support as defined in our licensing documents
                and where the information does not leave your control
              </li>
              <li>
                Presentations of MRI-Simmons data for the purposes of winning
                new clients or business, which can include marketing and media
                plans in accordance with your current MRI-Simmons data license
              </li>
            </ol>
          </li>
          <li>
            Quoting MRI-Simmons data in advertisements and promotional material
          </li>
          <li>
            Share and store MRI-Simmons data outside of your databases and
            platforms, including dashboards
          </li>
          <li>
            Share or load any MRI-Simmons data into any AI tool or model,
            whether a licensed third-party’s or your own private, closed AI
            tool/platform
          </li>
        </ol>
        <p style={{ fontWeight: 700 }}>It is strictly prohibited to:</p>
        <ol>
          <li>
            Share brand/retailer-identifiable data with another brand/retailer
          </li>
          <li>
            Share or load any MRI-Simmons data into a public AI tool/platform
            (e.g., ChatGPT)
          </li>
          <li>
            Use a bot or any other automated means to access MRI-Simmons systems
            or extract MRI-Simmons data
          </li>
          <li>
            Sharing raw MRI-Simmons data with unlicensed entities is expressly
            forbidden
          </li>
        </ol>
      </DialogContent>
      <DialogActions
        style={{
          display: 'flex',
          flexDirection: 'column',
          padding: '1.5rem 0 1.5rem 0',
        }}
      >
        <FormControlLabel
          style={{
            padding: '0 1.5rem 1.5rem 1.5rem',
          }}
          control={
            <Checkbox
              size="medium"
              checked={accepted}
              onChange={e => setAccepted(e.target.checked)}
            />
          }
          label={
            <span style={{ fontFamily: 'Open Sans' }}>
              By clicking here, I agree to the Important Reminder of Critical
              Usage Requirements and the MRI-Simmons Portal Services Terms and
              Conditions set forth above.
            </span>
          }
        />
        <GenericButton
          name="Agree & Continue"
          btnStyle="small button"
          btnDisabled={!accepted}
          onBtnClick={acceptedOnClick}
        />
      </DialogActions>
    </Dialog>
  );
};

AcceptTermsModal.propTypes = {
  isOpen: PropTypes.bool,
  acceptedOnClick: PropTypes.func,
};

export default AcceptTermsModal;
